enum StatusCode {
  Success = 200,
  BadRequest = 400,
  Unauthenticated = 401,
  Unauthorized = 403,
  NotFound = 404,
  ServerError = 500,
}

export default StatusCode;